import React from "react";

import { DomainsCircle } from "src/pages/reports/fsci/v1/graphics/domains_circle";

/*
 * Component
 */

export const Overview = (): React.ReactElement => {
    return (
        <>
            <div className="report-overview-wrapper">
                <p>
                    Thank you for your school’s participation in the Flourishing School Culture Instrument (FSCI). Your
                    school’s profile, based on the results of the FSCI as mapped on to the validated Flourishing School
                    Culture Model (FSCM), is designed to highlight areas of existing strength as well as opportunities
                    for growth and improvement. Statistically generated insights from the FSCI have the potential to
                    inform strategic planning and budgeting, professional development decisions, programmatic
                    priorities, marketing and promotional efforts, and much more.
                </p>
                <p>
                    Your school’s report consists of two main sections. We suggest beginning by clicking the blue bar,
                    “Explore Strengths and Growth Opportunities,” at the bottom of this page. This will lead you to the
                    five strengths and five growth opportunities that are unique to your school. Next, you can explore
                    benchmark data for all domains and their related constructs by clicking the interactive graphic
                    “Explore the Domains” below.
                </p>
                <p>
                    As with most institutional survey research, it is important to note that schools will benefit the
                    most fully when the reported findings are used to generate reflection, dialogue, and collaborative
                    planning for the present and the future. We pray the insights in this report will help your school
                    to continue to grow in the five domains of Christian school flourishing, and that ultimately, “May
                    the Lord cause you to flourish, both you and your children” (Psalm 115:14 NIV).
                </p>

                <div className="overview-divider" />

                <h2 className="large">Explore your results by domain.</h2>
                <p className="text-align-center">Click on the interactive graphic below to navigate between domains.</p>

                <DomainsCircle />
            </div>
        </>
    );
};
